var organization_cell_comp, organization_header_cell_comp;

import {
  HeaderFieldCellMixins,
  FieldCellMixins
} from './mixins.js';

organization_cell_comp = {
  mixins: [FieldCellMixins],
  data: function() {
    return {
      count: this._getOrganizations().length,
      initialOrganizations: this._getOrganizations()
    };
  },
  template: `<div class="organization-chips table-chips">
  <div class="slp-tooltip" v-if="showToolTip" :data-title="toolTip"></div>
  <div class="chips">
    <span class="chip mr-1 text-ellipsis"
          v-for='organization in organizations'
          :key='organization.id'
          ref="organizationChipRef">{{ organization.name }}</span>
  </div>
  <span class="chip-placeholder chip" v-if="showEllipsis">...</span>
</div>`,
  mounted: function() {
    var chipChildren;
    chipChildren = this.$refs.organizationChipRef;
    if (!chipChildren) {
      return;
    }
    return this._setChipCountFunc(chipChildren, this.$el.offsetWidth);
  },
  computed: {
    showEllipsis: function() {
      return this.showToolTip && (this.initialOrganizations.length > 1);
    },
    toolTip: function() {
      return _.map(this.initialOrganizations, function(organization) {
        return organization.name;
      }).join('、');
    },
    organizations: function() {
      if (this.showToolTip) {
        return this.initialOrganizations.slice(0, this.count);
      } else {
        return this.initialOrganizations;
      }
    },
    showToolTip: function() {
      return this.count < this.initialOrganizations.length || this.count === 1;
    }
  },
  methods: {
    _getOrganizations: function() {
      var entry;
      if (this.entries.length) {
        entry = this.entries[0];
        // -17代表是所有组织的特殊字段
        if (this.field.id === -17) {
          return entry.value;
        } else {
          return [
            {
              name: entry.value,
              id: entry.value_id
            }
          ];
        }
      } else {
        return [];
      }
    },
    _setChipCountFunc: function(chipChildren, maxWidth) {
      var chipChild, i, len, num, width;
      num = 0;
      width = 0;
      for (i = 0, len = chipChildren.length; i < len; i++) {
        chipChild = chipChildren[i];
        // chip的margin-right是8px
        width += chipChild.offsetWidth + 8;
        if (width > maxWidth && num > 0) {
          break;
        }
        num++;
      }
      return this.count = num;
    }
  }
};

export {
  organization_cell_comp as OrganizationCell,
  organization_cell_comp as HoldOrganizationCell
};

organization_header_cell_comp = {
  mixins: [HeaderFieldCellMixins],
  template: `<div class="filter-field-popover">
  <div class="filter-params-container">
    <div class="input-control left-addon">
      <input type="text"
             class='controlled-input bordered'
             placeholder='搜索'
             v-model.trim='keyword'
             @keyup.enter='updateFilter' />
      <div class="addon">
        <i class="slp-search"></i>
      </div>
    </div>
  </div>
</div>`
};

export {
  organization_header_cell_comp as OrganizationHeaderCell,
  organization_header_cell_comp as HoldOrganizationHeaderCell
};
